import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import AlertErrorForm from "../component/AlertErrorForm";
import Spinner from "../component/Spinner";
import moment from "moment";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { LIST_NATION } from "../configs";
import { useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import DateTimePicker from "react-datetime-picker";
import SearchBoxModal from "../component/SearchBoxModal";
import { Link } from "react-router-dom";
import { checkRole } from "../model";
// import UploadModal from "../component/UploadModal";
// import LoadCustomizer from "../component/LoadCustomizer";

export default function FormTTS() {
    const { user } = useSelector((state) => state.auth);

    const { id } = useParams();
    const [autoRefresh, setAutoRefresh] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [dateSelect, setDateSelect] = useState({
        birthday: null, cccd_date: null, birthday_child_1: null, birthday_child_2: null, birthday_child_3: null, datejoining: null, ngaynghiviec: null,
        datehdtv_start: null, datehdtv_end: null, datehdld_start_1: null, datehdld_end_1: null, datehdld_start_2: null, datehdld_end_2: null, datehdld_start_3: null, datehdld_end_3: null, hd_status: null
    });
    const [newCode, setNewCode] = useState();
    const allowSetRoles = checkRole(user, 'list-users', 'roles');
    const rolesAllCompany = checkRole(user, 'list-users', 'viewallcompany');
    // const rolesAllPart = checkRole(user, 'list-users', 'viewallpart');

    const defaultdetail = {
        author_id: user.data.id,
        fullname: '',
        code: newCode ? newCode : '',
        oldcode: '',
        sex: '',
        mobile: '',
        email: '',
        birthday: '',
        nation: '',
        address: '',
        status: 3,
        cccd: '',
        company_id: user.data.company_id,
        part_id: user.data.part_id,
        chucvu_id: '',
        datejoining: '',
        role_id: 2,
        typeaccount: 2,
        dateCCCD: '',
        cccd_address: '',
        address_tc: '',
        dctc: '',
        bank_id: '',
        bhxh_id: '',
        mst_id: '',
        qualification: '',
        majors: '',
        highschool: '',
        marital_status: '',
        fullname_love: '',
        total_child: '',
        fullname_child_1: '',
        birthday_child_1: '',
        fullname_child_2: '',
        birthday_child_2: '',
        fullname_child_3: '',
        birthday_child_3: '',
        time_test: '',
        datehdtv_start: '',
        datehdtv_end: '',
        datehdld_start_1: '',
        datehdld_end_1: '',
        datehdld_start_2: '',
        datehdld_end_2: '',
        datehdld_start_3: '',
        datehdld_end_3: '',
        hd_status: '',
        luong_ct: '',
        ngaynghiviec: '',
        checkin_status: 1,
        usertype:2
    }
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "users/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            // console.log(res.data.data)
                            if (mounted) {
                                const dataif = res.data.data
                                if(!dataif.leave) dataif.leave = 0
                                if(!dataif.songaybu) dataif.songaybu = 0
                                setDetail(dataif);
                                setDateSelect({
                                    birthday: dataif.birthday, cccd_date: dataif.cccd_date, birthday_child_1: dataif.birthday_child_1, birthday_child_2: dataif.birthday_child_2, birthday_child_3: dataif.birthday_child_3, datejoining: dataif.datejoining, ngaynghiviec: dataif.ngaynghiviec,
                                    datehdtv_start: dataif.datehdtv_start, datehdtv_end: dataif.datehdtv_end, datehdld_start_1: dataif.datehdld_start_1, datehdld_end_1: dataif.datehdld_end_1, datehdld_start_2: dataif.datehdld_start_2, datehdld_end_2: dataif.datehdld_end_2, datehdld_start_3: dataif.datehdld_start_3, datehdld_end_3: dataif.datehdld_end_3
                                })
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            } else {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "render_code?usertype=2", user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            // console.log(res.data.data)
                            if (mounted) {
                                setNewCode(res.data.data)
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, autoRefresh]
    );
    let validForm = {
        fullname: Yup.string().trim().nullable().required('Nhập họ và tên ').max(150, "Độ dài không quá 150 ký tự"),
        code: Yup.string().trim().nullable().required('Nhập mã số thực tập sinh'),
        sex: Yup.string().trim().nullable().required('Chọn giới tính'),
        birthday: Yup.string().trim().nullable().required('Chọn ngày sinh'),
        // mobile: Yup.string().trim().nullable().required('Nhập số điện thoại'),
        // email: Yup.string().trim().nullable().required('Nhập địa chỉ email'),
        role_id: Yup.string().trim().nullable().when("typeaccount", (type) => {
            if (type < 2) return Yup.string().required("Chọn quyền hạn tài khoản")
        })
    }

    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape(validForm),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            delete values["id"];

            setLoading(true)
            console.log(values);
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'users/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        setAutoRefresh(!autoRefresh)
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật tài khoản thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                Axios.post(URL_LIST_ALL + 'users', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới tài khoản thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    const handleDate = (name, value) => {
        formik.setFieldValue(name, moment(value).format('YYYY-MM-DD'))
        formik.setFieldTouched(name)
        let newDate = Object.assign({}, dateSelect)
        newDate[name] = value
        setDateSelect(newDate)
    };

    useEffect(function () {
        if (id > 0 && detail) {
            let uCode = detail.code
            Axios.get(URL_LIST_ALL + "cong_nhansu?user_code=" + uCode, user.config)
                .then(async (res) => {
                    if (res.data.status === "success") {
                        if (res.data.data && res.data.data[0]) {
                            const congnhasu = res.data.data[0]
                            formik.setFieldValue('leave', congnhasu.songayphep ? congnhasu.songayphep : '')
                            formik.setFieldValue('songaybu', congnhasu.songaybu ? congnhasu.songaybu : '')
                        }
                    } else console.log(res.data.message);
                })
                .catch((err) => console.log(err));
        }

    }, [detail, id]);// eslint-disable-line

    return (
        <AkkhorLayout idrole="list-thuc-tap-sinh">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/list-thuc-tap-sinh">Quản lý thực tập sinh</Link>
                    </li>
                    <li>{id ? 'Sửa thông tin thực tập sinh' : 'Thêm mới thực tập sinh'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>{!id ? 'Thêm mới' : 'Sửa'} thực tập sinh</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">

                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Họ và tên <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("fullname")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="fullname"></AlertErrorForm>
                            </div>

                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Mã số thực tập sinh  <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32"  {...formik.getFieldProps("code")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="code"></AlertErrorForm>
                            </div>
                          
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Giới tính <span className="text-danger">*</span></label>
                                <select className="form-select height32" {...formik.getFieldProps("sex")}>
                                    <option value="" disabled>Hãy chọn giới tính</option>
                                    <option value="Nam">Nam</option>
                                    <option value="Nữ">Nữ</option>
                                    <option value="Khác">Khác</option>
                                </select>
                                <AlertErrorForm formik={formik} name="sex"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày sinh <span className="text-danger">*</span></label>
                                <DateTimePicker onChange={(value) => { handleDate('birthday', value) }} value={dateSelect.birthday ? new Date(dateSelect.birthday) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                <AlertErrorForm formik={formik} name="birthday"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Số CCCD/CMND: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("cccd")} />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày cấp CCCD/CMND: </label>
                                <DateTimePicker onChange={(value) => { handleDate('cccd_date', value) }} value={dateSelect.cccd_date ? new Date(dateSelect.cccd_date) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Nơi cấp CCCD/CMND: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("cccd_address")} />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Địa chỉ thường trú: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("address_tc")} />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Địa chỉ liên lạc</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("address")} />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Điện thoại <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("mobile")} />
                                <AlertErrorForm formik={formik} name="mobile"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Email</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("email")} />
                                <AlertErrorForm formik={formik} name="email"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Dân tộc</label>
                                <select className="form-select height32" {...formik.getFieldProps("nation")}>
                                    <option value="" >Chọn dân tộc</option>
                                    {LIST_NATION.map((nation, index) => <option value={nation} key={index.toString()}>{nation}</option>)}
                                </select>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Trình độ chuyên môn: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("qualification")} />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Chuyên ngành: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("majors")} />
                            </div>

                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Trường đào tạo: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("highschool")} />
                            </div>

                            <div className="col-12 mt-3" ></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Tình trạng hôn nhân</label>
                                <select className="form-select height32" {...formik.getFieldProps("marital_status")}>
                                    <option value="Chưa kết hôn" >Chưa kết hôn</option>
                                    <option value="Đã kết hôn" >Đã kết hôn</option>
                                    <option value="Đã ly hôn" >Đã ly hôn</option>
                                </select>
                            </div>
                            {( (formik.values.marital_status && formik.values.marital_status === "Đã kết hôn") || (formik.values.marital_status && formik.values.marital_status === "Đã ly hôn") ) &&
                                <>
                                    {formik.values.marital_status === "Đã kết hôn" &&
                                        <>
                                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                                <label>Họ Tên vợ/chồng: </label>
                                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("fullname_love")} />
                                            </div>
                                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                                <label>Số điện thoại vợ/chồng: </label>
                                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("phone_love")} />
                                            </div>
                                        </>
                                    }

                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Số con cái: </label>
                                        <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("total_child")} />
                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Tên con 1: </label>
                                        <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("fullname_child_1")} />
                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Sinh nhật con 1: </label>
                                        <DateTimePicker onChange={(value) => { handleDate('birthday_child_1', value) }} value={dateSelect.birthday_child_1 ? new Date(dateSelect.birthday_child_1) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Tên con 2: </label>
                                        <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("fullname_child_2")} />
                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Sinh nhật con 2: </label>
                                        <DateTimePicker onChange={(value) => { handleDate('birthday_child_2', value) }} value={dateSelect.birthday_child_2 ? new Date(dateSelect.birthday_child_2) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Tên con 3: </label>
                                        <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("fullname_child_3")} />
                                    </div>
                                    <div className="col-xl-3 col-lg-6 col-12 form-group">
                                        <label>Sinh nhật con 3: </label>
                                        <DateTimePicker onChange={(value) => { handleDate('birthday_child_3', value) }} value={dateSelect.birthday_child_3 ? new Date(dateSelect.birthday_child_3) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                    </div>
                                </>
                            }

                            <div className="col-12 mt-3" ></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Phòng ban </label>
                                <SearchBoxModal apiname={"parts"} placeholder="Chọn phòng ban" colvalue={'id'} colname={'title'} defaultValue={formik.values['part_id']} name='part_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('part_id', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="part_id"></AlertErrorForm>
                            </div>

                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Chức vụ </label>
                                <SearchBoxModal apiname={"chucvu"} placeholder="Chọn chức vụ" colvalue={'id'} colname={'title'} defaultValue={formik.values['chucvu_id']} name='chucvu_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('chucvu_id', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="chucvu_id"></AlertErrorForm>
                            </div>
                            {rolesAllCompany ?
                                <div className="col-xl-3 col-lg-6 col-12 form-group">
                                    <label>Công ty </label>
                                    <SearchBoxModal apiname={"company"} placeholder="Chọn công ty" colvalue={'id'} colname={'title'} defaultValue={formik.values['company_id']} name='company_id'
                                        onChange={async (e) => {
                                            await formik.setFieldValue('company_id', e)
                                        }}></SearchBoxModal>
                                    <AlertErrorForm formik={formik} name="company_id"></AlertErrorForm>
                                </div>
                                :
                                <input type="hidden" placeholder="" className="form-control height32" {...formik.getFieldProps("company_id")} />
                            }
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Người quản lý </label>
                                <SearchBoxModal apiname={"users"} placeholder="Chọn nhân sự" colvalue={'code'} colname={'fullname'} defaultValue={formik.values['master_code']} name='master_code'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('master_code', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="master_code"></AlertErrorForm>
                            </div>

                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Số ngày phép còn lại</label>
                                <input type="number" placeholder="" className="form-control height32" {...formik.getFieldProps("leave")} />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Số ngày nghỉ bù còn lại</label>
                                <input type="number" placeholder="" className="form-control height32" {...formik.getFieldProps("songaybu")} />
                            </div>
                            {allowSetRoles && <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Quyền <span className="text-danger">*</span></label>
                                <SearchBoxModal apiname={"roles"} placeholder="Chọn quyền" colvalue={'id'} colname={'title'} defaultValue={formik.values['role_id']} name='role_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('role_id', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="role_id"></AlertErrorForm>
                            </div>}

                            <div className="col-12 mt-3" ><hr /></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Chấm công</label>
                                <select className="form-select height32" {...formik.getFieldProps("checkin_status")}>
                                    <option value="1">Có</option>
                                    <option value="2">Không</option>
                                </select>
                            </div>

                            <div className="col-12 mt-3" ></div>
                            <div className="col-lg-3 col-12 form-group">
                                <label>Thời gian bắt đầu ca sáng</label>
                                <input type="time" placeholder="" className="form-control height32" {...formik.getFieldProps("timestart_sa")} />
                            </div>
                            <div className="col-lg-3 col-12 form-group">
                                <label>Thời gian kết thúc ca sáng</label>
                                <input type="time" placeholder="" className="form-control height32" {...formik.getFieldProps("timeend_sa")} />
                            </div>
                            <div className="col-lg-3 col-12 form-group">
                                <label>Thời gian bắt đầu ca chiều</label>
                                <input type="time" placeholder="" className="form-control height32" {...formik.getFieldProps("timestart_ch")} />
                            </div>
                            <div className="col-lg-3 col-12 form-group">
                                <label>Thời gian kết thúc ca chiều</label>
                                <input type="time" placeholder="" className="form-control height32" {...formik.getFieldProps("timeend_ch")} />
                            </div>

                            <div className="col-12 mt-3" ><hr /></div>

                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Số TK ngân hàng techcombank:	</label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("bank_id")} />
                            </div>

                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Số sổ BHXH: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("bhxh_id")} />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Mã số thuế: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("mst_id")} />
                            </div>
                            <div className="col-12 mt-3" ><hr /></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày gia nhập <span className="text-danger">*</span></label>
                                <DateTimePicker onChange={(value) => { handleDate('datejoining', value) }} value={dateSelect.datejoining ? new Date(dateSelect.datejoining) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                <AlertErrorForm formik={formik} name="datejoining"></AlertErrorForm>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Trạng thái làm việc: </label>
                                <select className="form-select height32" {...formik.getFieldProps("status")}>
                                    <option value="3" >Chưa nhận việc</option>
                                    <option value="2" >Đang thử việc</option>
                                    <option value="1" >Đang chính thức</option>
                                    <option value="0" >Đã Nghỉ</option>
                                </select>
                            </div>
                            {(formik.values.status === 0 || formik.values.status === "0") &&
                                <div className="col-xl-3 col-lg-6 col-12 form-group">
                                    <label>Ngày nghỉ việc: </label>
                                    <DateTimePicker onChange={(value) => { handleDate('ngaynghiviec', value) }} value={dateSelect.ngaynghiviec ? new Date(dateSelect.ngaynghiviec) : ''} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                </div>
                            }
                            <div className="col-12"></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Thời gian thử việc (tháng): </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("time_test")} />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày bắt đầu HĐ thử việc: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdtv_start', value) }} value={dateSelect.datehdtv_start ? new Date(dateSelect.datehdtv_start) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày kết thúc HĐ thử việc: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdtv_end', value) }} value={dateSelect.datehdtv_end ? new Date(dateSelect.datehdtv_end) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Lương thử việc (%): </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("time_test")} />
                            </div>
                            <div className="col-12"></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày bắt đầu HĐLĐ lần 1: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdld_start_1', value) }} value={dateSelect.datehdld_start_1 ? new Date(dateSelect.datehdld_start_1) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày kết thúc HĐLĐ lần 1: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdld_end_1', value) }} value={dateSelect.datehdld_end_1 ? new Date(dateSelect.datehdld_end_1) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày bắt đầu HĐLĐ lần 2: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdld_start_2', value) }} value={dateSelect.datehdld_start_2 ? new Date(dateSelect.datehdld_start_2) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày kết thúc HĐLĐ lần 2: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdld_end_2', value) }} value={dateSelect.datehdld_end_2 ? new Date(dateSelect.datehdld_end_2) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày bắt đầu HĐLĐ lần 3: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdld_start_3', value) }} value={dateSelect.datehdld_start_3 ? new Date(dateSelect.datehdld_start_3) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Ngày kết thúc HĐLĐ lần 3: </label>
                                <DateTimePicker onChange={(value) => { handleDate('datehdld_end_3', value) }} value={dateSelect.datehdld_end_3 ? new Date(dateSelect.datehdld_end_3) : null} format="dd-MM-y" className="form-control height32 air-datepicker" />
                            </div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Tình trạng hợp đồng: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("hd_status")} />
                            </div>

                            <div className="col-12 mt-3" ><hr /></div>
                            <div className="col-xl-3 col-lg-6 col-12 form-group">
                                <label>Lương chính thức: </label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("luong_ct")} />
                            </div>

                            <div className="col-12 mt-3" ></div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu tài khoản</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
